import { create } from 'zustand';
import type { useFetchLivePlayMutation } from '../queries/live/liveQueryHooks';

type ReturnedMutation = ReturnType<typeof useFetchLivePlayMutation>;

type UseFetchLivePlayMutationStore = Pick<ReturnedMutation, 'data' | 'status' | 'variables' | 'error'> & {
  data: ReturnedMutation['data'];
  getData: () => ReturnedMutation['data'];
  setData: (data: ReturnedMutation['data']) => void;

  status: ReturnedMutation['status'];
  getStatus: () => ReturnedMutation['status'];
  setStatus: (status: ReturnedMutation['status']) => void;

  variables: ReturnedMutation['variables'];
  getVariables: () => ReturnedMutation['variables'];
  setVariables: (variables: ReturnedMutation['variables']) => void;

  error: ReturnedMutation['error'];
  getError: () => ReturnedMutation['error'];
  setError: (error: ReturnedMutation['error']) => void;

  reset: () => void;
};

export const useFetchLivePlayMutationStore = create<UseFetchLivePlayMutationStore>((_set, _get) => ({
  data: undefined,
  getData: () => _get().data,
  setData: (data) => _set({ data }),

  status: 'idle',
  getStatus: () => _get().status,
  setStatus: (status) => _set({ status }),

  variables: undefined,
  getVariables: () => _get().variables,
  setVariables: (variables) => _set({ variables }),

  error: null,
  getError: () => _get().error,
  setError: (error) => _set({ error }),

  reset: () =>
    _set({
      data: undefined,
      status: 'idle',
      variables: undefined,
      error: null,
    }),
}));
